/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_S4Inputs */

const en_tut_draf_s4 = /** @type {(inputs: Tut_Draf_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When it is right, press **Salin draf untuk ditinjau** and paste it into the **Catatan** tab or a document.`)
};

const id_tut_draf_s4 = /** @type {(inputs: Tut_Draf_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau sudah benar, tekan **Salin draf untuk ditinjau** dan tempelkan ke tab **Catatan** atau ke dokumen.`)
};

/**
* | output |
* | --- |
* | "When it is right, press **Salin draf untuk ditinjau** and paste it into the **Catatan** tab or a document." |
*
* @param {Tut_Draf_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_s4 = /** @type {((inputs?: Tut_Draf_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_s4(inputs)
	return en_tut_draf_s4(inputs)
});